import React from 'react';

const AppDownloadModal = ({ isOpen, onClose, contentType = 'event' }) => {
  if (!isOpen) return null;
  
  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fadeIn"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-auto relative animate-slideUp"
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-3xl leading-none w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
          onClick={onClose} 
          aria-label="Close"
        >
          ×
        </button>
        
        <div className="p-8 text-center">
          <div className="mb-6 flex justify-center">
            <img 
              src="/yesod-logo.png" 
              alt="Yesod Logo" 
              className="w-20 h-20 object-contain rounded-xl shadow-md"
            />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            Experience More in the App
          </h2>
          
          <p className="text-gray-600 mb-6 leading-relaxed">
            Get the full experience with our mobile app! View this {contentType}, 
            RSVP, stay updated, and connect with your community.
          </p>
          
          <div className="space-y-3 mb-8 text-left">
            <div className="flex items-center gap-3">
              <span className="text-green-500 font-bold text-lg flex-shrink-0">✓</span>
              <span className="text-gray-700">One-tap RSVP</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-green-500 font-bold text-lg flex-shrink-0">✓</span>
              <span className="text-gray-700">Push notifications</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-green-500 font-bold text-lg flex-shrink-0">✓</span>
              <span className="text-gray-700">Full event calendar</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-green-500 font-bold text-lg flex-shrink-0">✓</span>
              <span className="text-gray-700">Community updates</span>
            </div>
          </div>
          
          {/* iOS Download Button */}
          <button 
            className="w-full bg-black hover:bg-gray-800 text-white font-semibold py-4 px-6 rounded-xl transition-colors mb-3 shadow-lg hover:shadow-xl flex items-center justify-center gap-3"
            onClick={() => window.open('https://apps.apple.com/us/app/yesod/id6748472269', '_blank')}
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            <span>Download on App Store</span>
          </button>
          
          {/* Android Download Button */}
          <button 
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-4 px-6 rounded-xl transition-colors mb-3 shadow-lg hover:shadow-xl flex items-center justify-center gap-3"
            onClick={() => window.open('https://play.google.com/store/apps/details?id=us.yesod.app', '_blank')}
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
            </svg>
            <span>Get it on Google Play</span>
          </button>
          
          <button 
            className="w-full text-gray-600 hover:text-gray-800 font-medium py-3 px-6 rounded-xl hover:bg-gray-100 transition-colors"
            onClick={onClose}
          >
            Continue on Web
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadModal;
